export { default as OpenPayments } from './OpenPayments';
